import React from 'react';
import Summary from '../../register/summary/Summary';
import Header from '../reports/components/Layout/Header';
import withNewDesignStyles from '../../common/hoc/withNewDesignStyles';
import { t } from '../../../modules/infra/i18n';

const DailySummaryReport = () => (
  <div>
    <Header title={t('reports:navigation.daily_summary')} />
    <div className="o-page-height o-flexbox o-flexbox--column">
      <Summary />
    </div>
  </div>
);

export default withNewDesignStyles(DailySummaryReport);
